const ApplicationMimeTypes = [
  'application/x-abiword',
  'application/x-freearc',
  'application/vnd.amazon.ebook',
  'application/x-bzip',
  'application/x-bzip2',
  'application/x-cdf',
  'application/epub+zip',
  'application/gzip',
  'application/json',
  'application/vnd.oasis.opendocument.presentation',
  'application/vnd.oasis.opendocument.spreadsheet',
  'application/vnd.oasis.opendocument.text',
  'application/ogg',
  'application/pdf',
  'application/vnd.rar',
  'application/rtf',
  'application/x-tar',
  'application/xml',
  'application/zip',
  'application/x-7z-compressed',
] as const satisfies `application/${string}`[];

export const ExcelMimeTypes = [
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
] as const satisfies `application/${string}`[];

const MicrosoftMimeTypes = [
  ...ExcelMimeTypes,
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
] as const satisfies `application/${string}`[];

const AudioMimeTypes = [
  'audio/aac',
  'audio/midi',
  'audio/x-midi',
  'audio/mpeg',
  'audio/ogg',
  'audio/opus',
  'audio/wav',
  'audio/webm',
] as const satisfies `audio/${string}`[];

const ImageMimeTypes = [
  'image/avif',
  'image/bmp',
  'image/gif',
  'image/vnd.microsoft.icon',
  'image/jpeg',
  'image/png',
  'image/svg+xml',
  'image/tiff',
  'image/webp',
  'image/heic',
  'image/heif',
] as const satisfies `image/${string}`[];

const TextMimeTypes = [
  'text/csv',
  'text/calendar',
  'text/plain',
  'text/xml',
] as const satisfies `text/${string}`[];

const VideoMimeTypes = [
  'video/x-msvideo',
  'video/mp4',
  'video/mpeg',
  'video/ogg',
  'video/mp2t',
  'video/webm',
] as const satisfies `video/${string}`[];

export const MimeTypes = [
  ...ApplicationMimeTypes,
  ...MicrosoftMimeTypes,
  ...AudioMimeTypes,
  ...ImageMimeTypes,
  ...TextMimeTypes,
  ...VideoMimeTypes,
] as const;

export type MimeType = (typeof MimeTypes)[number];

export const isMimeType = (value: unknown): value is MimeType =>
  MimeTypes.includes(value as MimeType);
